<h1 class="title">Shared Categories</h1>
<ng-select
  [items]="categories"
  placeholder="Select Category"
  [(ngModel)]="selectedCategory"
  (change)="selectCategory($event)"
  [multiple]="false"
></ng-select>
